import { getConfirmRedemtionSnippet, getRedeemProductSnippet } from "./api";
import { replaceHtml } from "./helper";
import { loadBestellenSnippet } from "./bestellenSnippetLoader";
// eslint-disable-next-line import/no-cycle, no-unused-vars
import { DownloadcodePage } from "downloadcode-page/main";

// eslint-disable-next-line consistent-return
export function updateContent(context) {
  const { state } = history;
  if (state && state.downloadCode) {
    return (state.checkoutId
      ? confirmProductRedemtion(context, state.downloadCode, state.checkoutId)
      : getRedeemProductSnippet(state.downloadCode))
      .then((r) => r.text())
      .then((html) => replaceHtml(context.content, html));
  }
  if (context.codeEingabe) {
    context.content.replaceChild(context.codeEingabe, context.content.firstElementChild);
  } else {
    location.href = "/downloadcode/";
  }
}

function confirmProductRedemtion(context, downloadCode, checkoutId) {
  return ensureBestellenSnippet(context.bestellenSnippetContainer, checkoutId)
    .then(() => new Promise((resolve, reject) => {
      let timeoutId;
      const event = new CustomEvent("checkout-kaufen-abschluss", { detail: { id: checkoutId } });

      const errorHandler = (e) => {
        window.removeEventListener("auftragsanlage-error", errorHandler);
        clearTimeout(timeoutId);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ message: e.detail.errorMsg });
      };

      const successHandler = () => {
        clearTimeout(timeoutId);
        window.removeEventListener("auftragsanlage-success", successHandler);
        resolve();
      };

      window.addEventListener("auftragsanlage-error", errorHandler);
      window.addEventListener("auftragsanlage-success", successHandler);

      dispatchEvent(event);

      timeoutId = setTimeout(() => {
        reject(new Error("Event timed out"));
      }, 60000);
    })).then(() => getConfirmRedemtionSnippet(downloadCode));
}

function ensureBestellenSnippet(container, checkoutId) {
  if (container.firstElementChild) return Promise.resolve();
  return loadBestellenSnippet(container, checkoutId);
}
